<template>
    <div>
        <v-btn
            @click="toggleAddDialog()"
            class="info text--white"
            slot="activator"
        >Add Emergency Contact
        </v-btn>
        <v-dialog
            :value="addPersonEmergencyContactDialog"
            max-width="500px"
        >
            <v-card>
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Add Emergency Contact</span>
                    <v-spacer />
                    <v-btn
                        @click="toggleAddDialog()"
                        fab
                        small
                        text
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md8
                                sm8
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addNameErrors"
                                    @blur="$v.addName.$touch()"
                                    @input="$v.addName.$touch()"

                                    label="Name"
                                    type="text"
                                    v-model="addName"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm4
                                xs12
                            >
                                <v-select
                                    :error-messages="addRelationshipErrors"
                                    :items="relationshipTypeList"
                                    @blur="$v.addRelationship.$touch()"
                                    @input="$v.addRelationship.$touch()"

                                    label="Relationship"
                                    type="text"
                                    v-model="addRelationship"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addTelephoneErrors"
                                    @blur="$v.addTelephone.$touch()"
                                    @input="$v.addTelephone.$touch()"

                                    label="Telephone"
                                    type="text"
                                    v-model="addTelephone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addMobilePhoneErrors"
                                    @blur="$v.addMobilePhone.$touch()"
                                    @input="$v.addMobilePhone.$touch()"

                                    label="Mobile"
                                    type="text"
                                    v-model="addMobilePhone"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addEmailAddressErrors"
                                    @blur="$v.addEmailAddress.$touch()"
                                    @input="$v.addEmailAddress.$touch()"

                                    label="Email"
                                    type="text"
                                    v-model="addEmailAddress"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addAddressLineOneErrors"
                                    @blur="$v.addAddressLineOne.$touch()"
                                    @input="$v.addAddressLineOne.$touch()"

                                    label="Address Line One"
                                    type="text"
                                    v-model="addAddressLineOne"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addAddressLineTwoErrors"
                                    @blur="$v.addAddressLineTwo.$touch()"
                                    @input="$v.addAddressLineTwo.$touch()"

                                    label="Address Line Two"
                                    type="text"
                                    v-model="addAddressLineTwo"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addTownErrors"
                                    @blur="$v.addTown.$touch()"
                                    @input="$v.addTown.$touch()"

                                    label="Town"
                                    type="text"
                                    v-model="addTown"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addCountyErrors"
                                    @blur="$v.addCounty.$touch()"
                                    @input="$v.addCounty.$touch()"

                                    label="County"
                                    type="text"
                                    v-model="addCounty"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-text-field
                                    :error-messages="addPostCodeErrors"
                                    @blur="$v.addPostCode.$touch()"
                                    @input="$v.addPostCode.$touch()"

                                    label="Postcode"
                                    type="text"
                                    v-model="addPostCode"
                                />
                            </v-flex>
                            <v-flex
                                md4
                                sm6
                                xs12
                            >
                                <v-autocomplete
                                    :error-messages="addPersonnelCountryIdErrors"
                                    :items="personnelCountryList"
                                    @blur="$v.addPersonnelCountryId.$touch()"
                                    @input="$v.addPersonnelCountryId.$touch()"
                                    item-text="name"

                                    item-value="personnelCountryId"
                                    label="Country"
                                    v-model="addPersonnelCountryId"
                                />
                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveNewItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeNewItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { FETCH_PERSON_EMERGENCY_CONTACT_LIST, SAVE_NEW_PERSON_EMERGENCY_CONTACT } from "@/store/person_emergency_contact/actions.js";
import { RESET_DEFAULT_NEW_PERSON_EMERGENCY_CONTACT, TOGGLE_NEW_PERSON_EMERGENCY_CONTACT_DIALOG, UPDATE_ADD_PERSON_EMERGENCY_CONTACT_FIELD } from "@/store/person_emergency_contact/mutations.js";
import { required, requiredIf, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';

    export default {
        name: "AddPersonEmergencyContactDialog",

        validations: {
            addName: {required},
            addRelationship: {required},
            addEmailAddress: {},
            addMobilePhone: {
                phone: requiredIf(function (form) {
                    return !form.addTelephone
                })
            },
            addTelephone: {
                phone: requiredIf(function (form) {
                    return !form.addMobilePhone
                })
            },
            addAddressLineOne: {required},
            addAddressLineTwo: {},
            addTown: {},
            addCounty: {},
            addPostCode: {required},
            addPersonnelCountryId: {required}
        },

        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        computed: {
            ...mapGetters(
            [

                "employmentTypeList",
                "personnelCountryList",
                "person",
                "relationshipTypeList"

            ],
            ),

            ...mapGetters(
            [
                "addPersonEmergencyContactDialog",
            ]
            ),

            addName: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.name;
                },
                set(value) {
                    this.updateNewValue('name', value);
                },
            },
            addNameErrors() {
                const errors = [];
                if (!this.$v.addName.$dirty) return errors;
                !this.$v.addName.required && errors.push('required.');
                return errors
            },
            addRelationship: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.relationship;
                },
                set(value) {
                    this.updateNewValue('relationship', value);
                },
            },
            addRelationshipErrors() {
                const errors = [];
                if (!this.$v.addRelationship.$dirty) return errors;
                !this.$v.addRelationship.required && errors.push('required.');
                return errors
            },
            addMobilePhone: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.mobilePhone;
                },
                set(value) {
                    this.updateNewValue('mobilePhone', value);
                },
            },
            addMobilePhoneErrors() {
                const errors = [];
                if (!this.$v.addMobilePhone.$dirty) return errors;
                this.$v.addMobilePhone.$invalid && errors.push('required.');
                return errors
            },
            addTelephone: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.telephone;
                },
                set(value) {
                    this.updateNewValue('telephone', value);
                },
            },
            addTelephoneErrors() {
                const errors = [];
                if (!this.$v.addTelephone.$dirty) return errors;
                this.$v.addTelephone.$invalid && errors.push('required.');
                return errors
            },
            addEmailAddress: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.emailAddress;
                },
                set(value) {
                    this.updateNewValue('emailAddress', value);
                },
            },
            addEmailAddressErrors() {
                return [];
            },
            addAddressLineOne: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.addressLineOne;
                },
                set(value) {
                    this.updateNewValue('addressLineOne', value);
                },
            },
            addAddressLineOneErrors() {
                const errors = [];
                if (!this.$v.addAddressLineOne.$dirty) return errors;
                !this.$v.addAddressLineOne.required && errors.push('required.');
                return errors
            },
            addAddressLineTwo: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.addressLineTwo;
                },
                set(value) {
                    this.updateNewValue('addressLineTwo', value);
                },
            },
            addAddressLineTwoErrors() {
                return [];
            },
            addTown: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.town;
                },
                set(value) {
                    this.updateNewValue('town', value);
                },
            },
            addTownErrors() {
                return [];
            },
            addCounty: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.county;
                },
                set(value) {
                    this.updateNewValue('county', value);
                },
            },
            addCountyErrors() {
                return [];
            },
            addPersonnelCountryId: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.personnelCountryId;
                },
                set(value) {
                    this.updateNewValue('personnelCountryId', value);
                },
            },
            addPersonnelCountryIdErrors() {
                const errors = [];
                if (!this.$v.addPersonnelCountryId.$dirty) return errors;
                !this.$v.addPersonnelCountryId.required && errors.push('required.');
                return errors
            },
            addPostCode: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.postCode;
                },
                set(value) {
                    this.updateNewValue('postCode', value);
                },
            },
            addPostCodeErrors() {
                const errors = [];
                if (!this.$v.addPostCode.$dirty) return errors;
                !this.$v.addPostCode.required && errors.push('required.');
                return errors
            },
            addComments: {
                get() {
                    return this.$store.state.person_emergency_contact.addPersonEmergencyContact.comments;
                },
                set(value) {
                    this.updateNewValue('comments', value);
                },
            },
        },

        mounted() {
            if (this.personId !== undefined) {
                this.resetNewItemToDefault(this.personId);
                this.updateNewValue('personId', this.personId);
            }
        },

        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_EMERGENCY_CONTACT_LIST,
                saveNewTableItemRecord: SAVE_NEW_PERSON_EMERGENCY_CONTACT,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_PERSON_EMERGENCY_CONTACT_DIALOG,
                // loadTableItemToEdit: LOAD_PERSON_SUMMARY_TO_EDIT,
                updateTableItemToAdd: UPDATE_ADD_PERSON_EMERGENCY_CONTACT_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_PERSON_EMERGENCY_CONTACT,
            }),
        }
    }
</script>

<style scoped>

</style>
